import { render, staticRenderFns } from "./IndexPageBrandSection.vue?vue&type=template&id=6bd75ce1&"
import script from "./IndexPageBrandSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageBrandSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports